export default "__VITE_ASSET__8fa4e9be__"